import type { TableView } from 'owa-mail-list-store';
import getMailListGroupHeaderGenerator from './getMailListGroupHeaderGenerator';

/**
 * Returns the header text for the group that contains the provided row key.
 */
export default function getParentGroupHeader(
    rowKey: string,
    tableView: TableView | undefined
): string | null {
    if (!rowKey || !tableView) {
        return null;
    }

    const headerGenerator = getMailListGroupHeaderGenerator(tableView);
    if (!headerGenerator || !headerGenerator.getGroupHeader) {
        return null;
    }

    const groupHeader = headerGenerator.getGroupHeader(rowKey, tableView);
    return groupHeader?.headerText ? groupHeader.headerText() : null;
}
